export default {
    SET_STATISTICS: "SET_STATISTICS",
    SET_BRIGADES: "SET_BRIGADES",
    SET_BRIGADES_BY_DATE: "SET_BRIGADES_BY_DATE",
    SET_BRIGADE_BY_DATE: "SET_BRIGADE_BY_DATE",
    SET_USER: "SET_USER",
    SET_USERS: "SET_USERS",
    SET_ACCESSORIES: "SET_ACCESSORIES",
    SET_NEW_ACCESSORY: "SET_NEW_ACCESSORY",
    SET_ORIGINAL_PRODUCTS: "SET_ORIGINAL_PRODUCTS",
    SET_NEW_GROUP: "SET_NEW_GROUP",
    SET_NEW_PRODUCT_BY_GROUP: "SET_NEW_PRODUCT_BY_GROUP",
    SET_NEWS: "SET_NEWS",
    SET_NEW_NEWS: "SET_NEW_NEWS",
    SET_PLAN: "SET_PLAN",
    SET_PLANS: "SET_PLANS",
    SET_NEW_PLAN: "SET_NEW_PLAN",
    SET_STATUS: "SET_STATUS",
    SET_UPDATED_STATISTIC: "SET_UPDATED_STATISTIC",
    DELETE_ACCESSORY: "DELETE_ACCESSORY",
    DELETE_PRODUCT: "DELETE_PRODUCT",
    DELETE_NEWS: "DELETE_NEWS",
    UPDATE_NEWS: "UPDATE_NEWS",
    SET_ARCHIVE: "SET_ARCHIVE",
    SET_TOTAL: "SET_TOTAL",
    DELETE_ARCHIVE: "DELETE_ARCHIVE",
    SET_RATES: "SET_RATES",
    SET_RATE: "SET_RATE",
    SET_DIVISION_RATE: "SET_DIVISION_RATE",
    UPDATE_USER_PASSWORD: "UPDATE_USER_PASSWORD",
    USER_UPDATE: "USER_UPDATE",
    SET_DEPARTMENTS: "SET_DEPARTMENTS",
    SET_BEFORE_STATISTIC: "SET_BEFORE_STATISTIC",
    SET_ARCHIVES: "SET_ARCHIVES",
    SET_TOTALS_MONTH: "SET_TOTALS_MONTH",
    SET_SUB_GROUPS: "SET_SUB_GROUPS",
    SET_NEW_SUB_GROUP: "SET_NEW_SUB_GROUP",
    UPDATE_PRODUCT_TYPE: "UPDATE_PRODUCT_TYPE",
    UPDATE_ACCESSORY_TYPE: "UPDATE_ACCESSORY_TYPE",
    SET_ERROR_BRIGADES: "SET_ERROR_BRIGADES",
};